'use client'

import { useEffect, useRef } from 'react'

const OPEN_MODAL_SELECTOR = [
  '[role="dialog"][data-state="open"]',
  '[role="alertdialog"][data-state="open"]',
].join(', ')

export function clearStaleRadixBodyLock(): void {
  if (typeof document === 'undefined') return
  if (document.body.style.pointerEvents !== 'none') return
  if (document.querySelector(OPEN_MODAL_SELECTOR)) return

  document.body.style.removeProperty('pointer-events')
}

/**
 * Recovers from Radix leaving its body interaction lock behind after the last
 * controlled modal closes. The check is limited to an open-to-closed
 * transition and never clears the lock while another modal is open.
 */
export function useRadixBodyLockCleanup(isAnyModalOpen: boolean): void {
  const wasOpenRef = useRef(isAnyModalOpen)

  useEffect(() => {
    const wasOpen = wasOpenRef.current
    wasOpenRef.current = isAnyModalOpen

    if (isAnyModalOpen || !wasOpen || typeof window === 'undefined') return

    let secondFrame = 0
    const firstFrame = window.requestAnimationFrame(() => {
      secondFrame = window.requestAnimationFrame(clearStaleRadixBodyLock)
    })

    return () => {
      window.cancelAnimationFrame(firstFrame)
      if (secondFrame) window.cancelAnimationFrame(secondFrame)
    }
  }, [isAnyModalOpen])
}
